import { ArrowRight, Plus, Star } from "lucide-react";
import HeroImage from "../Assests/program-image-2.jpg"

const avatars = [
  "https://static.vecteezy.com/system/resources/thumbnails/049/174/246/small/a-smiling-young-indian-man-with-formal-shirts-outdoors-photo.jpg",
  "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQJp0qhEgcOaRscS93404KdEg-j5Oqk8o36LQ&s",
  "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTFSaLz693rDjzK_V-nGa-tI7a9nMkKqyUt7g&s",
];

export default function Hero() {
  return (
    <section className="relative min-h-screen flex flex-col justify-end pb-20 overflow-hidden">
      {/* Background Image */}
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage:
            `url(${HeroImage})`,
        }}
      />

      {/* Dark Gradient Overlay */}
      <div className="absolute inset-0 bg-gradient-to-r from-black/75 via-black/50 to-transparent" />
      <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-black/20" />

      {/* Content */}
      <div className="relative z-10 max-w-[1280px] mx-auto px-6 lg:px-16 w-full">
        {/* Badge */}
        <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm border border-white/20 text-white text-xs font-semibold px-4 py-2 rounded-full mb-8">
          <span className="w-1.5 h-1.5 rounded-full bg-[#FF6B35] animate-pulse" />
          Play, Learn, And Shine
        </div>

        {/* Heading */}
       <hgroup className="mb-6" style={{ maxWidth: "680px" }}>
  <h2
    className="text-white font-extrabold"
    style={{
      fontFamily: "'Nunito', sans-serif",
      fontSize: "clamp(1.8rem, 4vw, 2.8rem)", // Slightly smaller
      marginBottom: "0.25rem",
    }}
  >
    Small Joy, Big Leaps:
  </h2>
  <h1
    className="text-white font-extrabold leading-[1.05]"
    style={{
      fontFamily: "'Nunito', sans-serif",
      fontSize: "clamp(2.8rem, 6vw, 5.2rem)",
    }}
  >
    Ranked Bangalore's Top 10 Preschool.
  </h1>
</hgroup>

        {/* Subtext */}
        <p
          className="text-white/75 font-medium leading-relaxed mb-10"
          style={{ maxWidth: "560px", fontSize: "clamp(0.95rem, 1.5vw, 1.05rem)" }}
        >
         Every smile. Every 'aha' moment. Every new word. At SeekersBay, we turn ordinary days into extraordinary learning adventures. Recognized as one of Bangalore's top preschools, we don't just teach — we create joyful moments your child will carry forever.
        </p>

        {/* Bottom Row */}
        <div className="flex flex-wrap items-center gap-8">
          {/* CTA Button */}
          <a
            href="/contact"
            className="inline-flex items-center gap-2.5 bg-[#FF6B35] hover:bg-[#e55a25] text-white font-bold px-8 py-4 rounded-full text-base transition-all duration-300 hover:shadow-xl hover:shadow-orange-500/40 hover:-translate-y-0.5 group"
          >
            Book A School Visit
            <span className="w-6 h-6 rounded-full bg-white/20 flex items-center justify-center group-hover:bg-white/30 transition-colors">
              <ArrowRight size={13} strokeWidth={2.5} />
            </span>
          </a>

          {/* Social Proof */}
          <div className="flex items-center gap-4">
            {/* Stacked Avatars */}
            <div className="flex items-center">
              {avatars.map((src, i) => (
                <div
                  key={i}
                  className="w-10 h-10 rounded-full border-2 border-white overflow-hidden"
                  style={{ marginLeft: i === 0 ? 0 : "-10px", zIndex: avatars.length - i }}
                >
                  <img src={src} alt="parent" className="w-full h-full object-cover" />
                </div>
              ))}
              {/* Plus Button */}
              <div
                className="w-10 h-10 rounded-full border-2 border-white bg-[#FF6B35] flex items-center justify-center"
                style={{ marginLeft: "-10px", zIndex: 0 }}
              >
                <Plus size={14} color="white" strokeWidth={3} />
              </div>
            </div>

            {/* Stars & Rating */}
            <div>
              <div className="flex items-center gap-1 mb-0.5">
                {[...Array(5)].map((_, i) => (
                  <Star
                    key={i}
                    size={15}
                    className="fill-[#FF6B35] text-[#FF6B35]"
                  />
                ))}
              </div>
              <p className="text-white text-xs font-semibold">
                4.9 / 5 Reviews
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 right-16 hidden lg:flex flex-col items-center gap-2">
        <div className="w-px h-12 bg-white/30" />
        <span className="text-white/40 text-xs font-medium tracking-widest rotate-90 origin-center mt-8">
          SCROLL
        </span>
      </div>
    </section>
  );
}